import HttpRequest from './HttpRequest';

export default class DriverService extends HttpRequest {
  static endpoint = 'admins';

  static async getAll() {
    this.endpoint = 'admins';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'admins';
    const response = await this.get(id);
    return response;
  }

  static async getBranchOfficesReport(id) {
    this.endpoint = 'admins/branch-offices-report';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'admins';
    const response = await this.post(data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'admins';
    const response = await this.delete(id);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'admins';
    const response = await this.put(id, data);
    return response;
  }

  static async uploadImage(data) {
    this.endpoint = 'admins/create-avatar';
    const response = await this.post(data);
    return response;
  }

  static async deleteImage(data) {
    this.endpoint = 'admins/delete-avatar';
    const response = await this.delete(data);
    return response;
  }
}
